<script>
    import Autocomplete from '@smui-extra/autocomplete';
    let valueStandard="";
  </script>
  
  <h3>Änderungsvorschlag</h3>
  <p>Vielen Dank für den Änderungsvorschlag! Das ÖGD_Atlas Team gibt sein Bestes den Vorschlag schnellst möglichst zu überprüfen und gegebenenfalls dauerhaft in das Modell zu übernehmen.</p>
  